import { attachFunctionToCallback, loadScript, getNovSchema } from "../utility";

import { setExperimentsData, getProfileData, getExperiment } from './DataStore';

export function requestFeatureExperimentation(postAction) {
	let callbackName = "featureFlags";

	let profile = getProfileData().Profile.split(".");
	if (profile.length !== 3) {
		postAction();
		return;
	}

	let deviceId = `NOV.${profile[0]}`;

	let url = `${getNovSchema()}${window.novSelect.baseUrl}/experimentation/get?callback=novSelect.${callbackName}&deviceId=${deviceId}`

	let callback = data => {
		setExperimentsData(data);
		postAction();
	};

	attachFunctionToCallback(callback, callbackName);

	loadScript(url);
}

export function logExperimentExposure(experimentId) {
	let profile = getProfileData().Profile.split(".");
	if (profile.length !== 3) {
		return;
	}

	let deviceId = `NOV.${profile[0]}`;

	let experiment = getExperiment(experimentId);
	if (experiment) {
		let url = `${getNovSchema()}${window.novSelect.baseUrl}/experimentation/logExposureEvent?deviceId=${deviceId}&experimentId=${experiment.ExperimentId}&variant=${experiment.Flag}`;
		loadScript(url);
	}
}



// WEBPACK FOOTER //
// ./src/data/FeatureExperimentation.js